import { render, staticRenderFns } from "./AdminCategoriesRecursive.vue?vue&type=template&id=2e314af8&scoped=true&"
import script from "./AdminCategoriesRecursive.vue?vue&type=script&lang=js&"
export * from "./AdminCategoriesRecursive.vue?vue&type=script&lang=js&"
import style0 from "./AdminCategoriesRecursive.vue?vue&type=style&index=0&id=2e314af8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e314af8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e314af8')) {
      api.createRecord('2e314af8', component.options)
    } else {
      api.reload('2e314af8', component.options)
    }
    module.hot.accept("./AdminCategoriesRecursive.vue?vue&type=template&id=2e314af8&scoped=true&", function () {
      api.rerender('2e314af8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/Workspace/AdminPage/AdminCategoriesRecursive.vue"
export default component.exports